import type { Breadcrumb } from './breadcrumbs';
import { EFlavorsRaw } from './breadcrumbs.flavors';
import type { FlavorKeys } from './breadcrumbs.types';

/** Breadcrumb flavors that mark the result of a person upsync to Raiser's Edge NXT */
export const RAISERS_EDGE_UPSYNC_FLAVORS: readonly FlavorKeys[] = [
  'raisers_edge_upsync_created',
  'raisers_edge_upsync_failed',
  'raisers_edge_upsync_skipped',
];

/** Removes each failed upsync mark whose person event also has a created or skipped mark. */
export function hideSupersededUpsyncFailures(breadcrumbs: Breadcrumb[]): Breadcrumb[] {
  const syncedEventIds = new Set(
    breadcrumbs
      .filter(
        (crumb) =>
          crumb.get('flvr') === EFlavorsRaw.raisers_edge_upsync_created ||
          crumb.get('flvr') === EFlavorsRaw.raisers_edge_upsync_skipped,
      )
      .map((crumb) => crumb.get('crm_sync')?.event_id)
      .filter((eventId): eventId is string => !!eventId),
  );
  if (!syncedEventIds.size) {
    return breadcrumbs;
  }
  return breadcrumbs.filter((crumb) => {
    if (crumb.get('flvr') !== EFlavorsRaw.raisers_edge_upsync_failed) {
      return true;
    }
    const eventId = crumb.get('crm_sync')?.event_id;
    return !eventId || !syncedEventIds.has(eventId);
  });
}
